import { useState, useEffect } from "react";
import * as Sentry from "@sentry/browser";

import { fetchJSON } from "lib/fetch";
import { getConfig } from "site-config";

import { TAPIResponse } from "../../types";
import { API_STATES, createAuthHeader } from "../../helpers";
import { showAPIExceptionMessage } from "../../api-exception-messages";
import { TOrderProductsRelationsSummary } from "./use-order-products-relations-summary.types";

export type TParams = {
    snackbar: any;
    payload: {
        nuItems: {
            productId: string;
            itemId: string;
            upc: string | null;
        }[];
        isOIDCTokenValid: boolean;
    };
};

export const useOrderProductsRelationsSummary = ({
    payload,
    snackbar,
}: TParams): TAPIResponse<TOrderProductsRelationsSummary, any> => {
    const { RSERIES_MARKETPLACE_DATA_FLOW_BASE_URL } = getConfig();
    const [state, setState] = useState<TAPIResponse<TOrderProductsRelationsSummary, string>>(API_STATES.default);

    const APIStates = API_STATES.getStates(setState);

    useEffect(() => {
        if (payload.nuItems.length && payload.isOIDCTokenValid) {
            APIStates.pending();
            fetchJSON<TOrderProductsRelationsSummary>(
                `${RSERIES_MARKETPLACE_DATA_FLOW_BASE_URL}/product-relations/summary`,
                {
                    method: "POST",
                    headers: createAuthHeader(),
                    body: JSON.stringify(payload),
                }
            )
                .then(APIStates.success)
                .catch((error) => {
                    Sentry.captureMessage(error, {
                        level: "error",
                        tags: {
                            feature: "ExportOrderToPOS",
                            serviceName: "MarketplaceDataFlow",
                            source: "B2B",
                            statusCode: error.statusCode,
                        },
                    });
                    showAPIExceptionMessage({ snackbar });
                    APIStates.error(error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [payload.nuItems, payload.isOIDCTokenValid]);

    return state;
};
